(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["raha-discovery"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('raha-shape-preview')) {
  customElements.define('raha-shape-preview', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const signal = this.controller.signal;
      const image = this.querySelector('[data-ring-preview]');
      if (!image) return;
      const cards = Array.from(this.closest('.rj-discovery').querySelectorAll('.rj-card--shape[data-ring-image]'));
      let active = cards[0];
      if (active) active.classList.add('is-previewed');
      const show = (card) => {
        if (!card.dataset.ringImage) return;
        cards.forEach(item => item.classList.toggle('is-previewed', item === card));
        active = card;
        image.src = card.dataset.ringImage;
        image.alt = card.dataset.ringTitle + ' diamond ring';
      };
      cards.forEach(card => {
        card.addEventListener('mouseenter', () => show(card), { signal });
        card.addEventListener('focus', () => show(card), { signal });
        let selectedOnTouch = false;
        card.addEventListener('pointerdown', event => {
          selectedOnTouch = event.pointerType === 'touch' && active !== card;
          if (event.pointerType === 'touch') show(card);
        }, { signal });
        card.addEventListener('click', event => {
          if (selectedOnTouch) { event.preventDefault(); selectedOnTouch = false; }
        }, { signal });
      });
      this.observer = new IntersectionObserver(entries => {
        if (!entries.some(entry => entry.isIntersecting)) return;
        cards.forEach(card => { if (card.dataset.ringImage) { const preload = new Image(); preload.src = card.dataset.ringImage; } });
        this.observer.disconnect();
      }, { rootMargin: '300px' });
      this.observer.observe(this);
    }
    disconnectedCallback() {
      if (this.controller) this.controller.abort();
      if (this.observer) this.observer.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
